import { Injectable, inject } from '@angular/core';

import { TranslateLoader } from '@ngx-translate/core';
import { Observable, defaultIfEmpty, forkJoin, map } from 'rxjs';

import { CamTranslationRegistryService } from '@camelot/translation';

@Injectable()
export class E2eTranslationLoader implements TranslateLoader {
  private readonly _registry = inject(CamTranslationRegistryService);

  getTranslation(lang: string): Observable<object> {
    return forkJoin([...this._registry.getTranslations(lang)]).pipe(
      map(translations => translations.reduce<object>((acc, translation) => Object.assign(acc, translation ?? {}), {})),
      defaultIfEmpty({})
    );
  }
}
